import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SOTService } from '../../services';

@Component({
  selector: 'sot-langcall',
  templateUrl: "./langcall.component.html",
  styleUrls: ["./langcall.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LangCall implements OnInit, OnDestroy {
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;
  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
  }

  public ngOnInit(): void {
    console.debug("--- sot-langcall ngOnInit")
    this.isModeOne = this._sotService.useModeOne();
    this.isModeTwo = this._sotService.useModeTwo();
    this.PushChanges();
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-langcall ngOnDestroy")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("LangCall.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /** Öffnet einen Dialog, wo der user bestätigen kann, dass er den Service rufen möchte */
  public callService(): void {
    this._sotService.OpenServiceDialog();
  }

  /**checks whether there is text for the service call button
   *if text is empty service call button won't display*/
  public get hasServiceCallLabel() {
    return this._sotService.hasServiceCallLabel('button_service');
  }

  /** property, ob Sprachwechsel möglich ist */
  public get show_langauges_btn(): boolean {
    return this._sotService.GetSettings().languages.length > 1;
  }

  private _show_choose_languages: boolean = false;
  /** property an der gebunden wird, ob die Sprachauswahl angezeigt wird */
  public get show_choose_languages(): boolean {
    return this._show_choose_languages;
  }

  /** Öffnet die Sprachauswahl */
  public openChooseLanguages(): void {
    this._show_choose_languages = true;
    this.PushChanges();
  }

  /** Schließt die Sprachauswahl */
  public closeChooseLanguages(): void {
    this._show_choose_languages = false;
    this.PushChanges();
  }

  /** Sprachen zum Binden */
  public get languages(): { key: string, image: string, active: boolean }[] {
    const current_language = this._sotService.GetCurrentLanguage();
    const sotSettings = this._sotService.GetSettings();
    return sotSettings.languages.map((language_key) => ({
      key: language_key,
      image: sotSettings.getLanguageFlagUrl(language_key),
      active: language_key == current_language
    }));
  }

  /** Gibt den Text für eine bestimmte Sprache zurück */
  public getLanguageText(language_key: string): string {
    try {
      return this._sotService.TranslateKeyToLanguage(language_key, "button_language");
    } catch (error) {
      this._sotService.coreLogService.error("LangCall.getLanguageText", "TranslateKeyToLanguage catch", error);
      return "Language"; // Fallback
    }
  }

  /** Gibt den zusammengesetzten Text für alle Sprachen zurück */
  public get languageText(): string {
    return this._sotService.GetSettings().languages.map((language_key) => this.getLanguageText(language_key)).join(" / ");
  }
  /** versucht die Sprache zu wechseln und schließt die Sprachauswahl */
  public chooseLanguage(language: string): void {
    const me = this;
    me._sotService.ChangeLanguage(language).then(() => {
      me.closeChooseLanguages();
    }).catch((error) => {
      me.closeChooseLanguages();
      me._sotService.coreLogService.error("LangCall.chooseLanguage", "ChangeLanguageAsync catch", error);
    });
  }
}